<template lang="html">
  <div class="logo">
    <LogoIcon class="logo__image" />
  </div>
</template>

<script>
import anime from 'animejs'
import checkViewport from 'beisheim/mixins/check-viewport'

import LogoIcon from 'beisheim/assets/images/logos/beisheim-stiftung-logo-wortbildmarke.svg'

export default {
  components: {
    LogoIcon
  },
  mixins: [checkViewport],
  computed: {
    animation () {
      const timeline = anime.timeline()
      const duration = 2000

      timeline
        .add({
          targets: ['[data-logo="group"]'],
          opacity: [0, 1],
          transform: ['scale(0.9) rotate(125, 22, 23)', 'scale(1) rotate(0, 22, 23)'],
          duration,
          easing: 'easeOutSine',
          offset: 0
        })
      return timeline
    }
  },
  watch: {
    scrolledToBottom () {
      this.animation.seek(0)
      this.animation.play()
    }
  },
  mounted () {
    this.animation.play()
    this.$el.addEventListener('mouseover', this.mouseOver)
  },
  methods: {
    mouseOver () {
      this.animation.seek(0)
      this.animation.play()
    }
  }
}
</script>

<style lang="scss">
@import 'beisheim/scss/breakpoints';
.logo {
  display: block;
}

.logo__image {
  width: 100%;
  display: block;
}
</style>
